module.exports = __webpack_public_path__ + "static/media/BankIDColorIcon.7f8f5380.svg";